// De voorlopige live-rang. Sorteer eerst op tijd (incl. straftijd: hoe kleiner,
// hoe beter), daarna op voortgang in de race (verder = hoger). De index in de
// resulterende lijst is de voorlopige rang. Dit is dezelfde logica die de
// /positions-view (LivePositions) al gebruikt — hier gedeeld zodat /live dezelfde
// "echte" rang toont.
const EVENT_ORDER = ['stoppedSwimming', 'startedBiking', 'stoppedBiking', 'startedRunning', 'finished'];

export function sortByLiveRank(players) {
  return [...players]
    .sort((p1, p2) => (p1.time + (p1.penaltyTime || 0)) - (p2.time + (p2.penaltyTime || 0)))
    .sort((p1, p2) => EVENT_ORDER.indexOf(p2.event) - EVENT_ORDER.indexOf(p1.event));
}
